"use client"

import React from 'react';

const vehicles = [
  {
    id: 'sedan',
    name: 'Standard Sedan (4 Seats)',
    image: '/sedan.png',
    capacity: '3 Passengers',
    luggage: '3 Suitcases',
    features: ['Free WiFi', 'A/C', 'Free Water', 'English Driver']
  },
  {
    id: 'suv',
    name: 'SUV / MPV (7 Seats)',
    image: '/suv.png',
    capacity: '5 Passengers',
    luggage: '5 Suitcases',
    features: ['Extra Space', 'A/C', 'Free Water', 'English Driver']
  },
  {
    id: 'van',
    name: 'Minivan (16 Seats)',
    image: '/minivan.png',
    capacity: '12 Passengers',
    luggage: '10 Suitcases',
    features: ['Large Group', 'A/C', 'Free Water', 'English Driver']
  }
];

export default function FleetComponent({ lang }) {
  const t = {
    en: { title: 'Our Premium Fleet', subtitle: 'Choose the perfect vehicle for your journey', book: 'Book Now' },
    vi: { title: 'Đội Xe Cao Cấp', subtitle: 'Lựa chọn dòng xe phù hợp cho chuyến đi của bạn', book: 'Đặt Xe Ngay' },
    zh: { title: '我们的高级车队', subtitle: '为您的旅程选择完美的车辆', book: '立即预订' },
    ko: { title: '우리의 프리미엄 차량', subtitle: '여정에 완벽한 차량을 선택하세요', book: '지금 예약' },
    ja: { title: 'プレミアムフリート', subtitle: 'あなたの旅に最適な車両をお選びください', book: '今すぐ予約' }
  };

  const currentT = t[lang] || t['en'];

  const handleBook = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section id="fleet" style={{ padding: '60px 20px', background: '#f5f7fa' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <h2 style={{ fontSize: '2.5rem', color: '#0F2027', marginBottom: '10px' }}>{currentT.title}</h2>
          <p style={{ fontSize: '1.1rem', color: '#666' }}>{currentT.subtitle}</p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' }}>
          {vehicles.map(vehicle => (
            <div key={vehicle.id} style={{ background: 'white', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.08)', transition: 'transform 0.3s ease' }}>
              <div style={{ height: '220px', overflow: 'hidden' }}>
                <img src={vehicle.image} alt={vehicle.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              <div style={{ padding: '25px' }}>
                <h3 style={{ fontSize: '1.4rem', color: '#0F2027', marginBottom: '15px' }}>{vehicle.name}</h3>
                
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px', paddingBottom: '15px', borderBottom: '1px solid #eee' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#555' }}>
                    <span>👥</span> {vehicle.capacity}
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#555' }}>
                    <span>🧳</span> {vehicle.luggage}
                  </div>
                </div>

                <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 25px 0', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                  {vehicle.features.map((feature, index) => (
                    <li key={index} style={{ fontSize: '0.9rem', color: '#666', display: 'flex', alignItems: 'center', gap: '5px' }}>
                      <span style={{ color: '#D4AF37' }}>✓</span> {feature}
                    </li>
                  ))}
                </ul>

                <button 
                  onClick={handleBook}
                  style={{ width: '100%', padding: '12px', background: '#D4AF37', color: 'black', border: 'none', borderRadius: '6px', fontSize: '1.1rem', fontWeight: 'bold', cursor: 'pointer', transition: 'background 0.3s' }}
                >
                  {currentT.book}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
